import Transfer from './Transfer';

export default Transfer;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/transfer/index.js
// module id = 457
// module chunks = 0